import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { useUserSettings } from "../user";
import { i18n } from "../i18n";
import { HashLink } from "react-router-hash-link";
import styles from "./styles.module.css";
import logo from "./../pics/logo_transparent_2.png";
import Instagram from "@mui/icons-material/Instagram";
// import RoomServiceIcon from "@mui/icons-material/RoomService";
import HeadphonesSharpIcon from "@mui/icons-material/HeadphonesSharp";
import Place from "@mui/icons-material/Place";
import { motion } from "framer-motion";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [settings, setSettings] = useUserSettings();
  const { language } = settings;

  const setEnglish = () => {
    setSettings({ ...settings, language: "en" });
  };

  const setSpanish = () => {
    setSettings({ ...settings, language: "es" });
  };

  const setPortuguese = () => {
    setSettings({ ...settings, language: "pr" });
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const Drawer = ({ show, onClose, isOpen }) => {
    const drawerRef = useRef();

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (drawerRef.current && !drawerRef.current.contains(event.target)) {
          onClose(); // Call onClose if clicked outside
        }
      };

      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen, onClose]);

    return (
      <motion.div
        ref={drawerRef}
        className={styles.navbaropen}
        initial={{ y: "-100%" }} // Start hidden
        animate={{ y: show ? "0%" : "-100%" }} // Slide in/out
        transition={{ type: "spring", stiffness: 300, damping: 30 }} // Smooth animation
      >
        <div className="options">
          <Link className="option" to={"/"} onClick={toggle}>
            <text className="text">{i18n({ index: "home", language })}</text>
          </Link>
          <a className="option" href="https://imarangatu.meitre.com/">
            <text className="text">{i18n({ index: "reserve", language })}</text>
          </a>
          <Link className="option" to={"/contact"} onClick={toggle}>
            <text className="text">{i18n({ index: "contact", language })}</text>
          </Link>
          <div className="option">
            <Link class="nav_center" to={"/music"} onClick={toggle}>
              <HeadphonesSharpIcon
                style={{
                  fontSize: "37px",
                  paddingRight: "15px",
                  // marginBottom: "-5px",
                }}
                className="icons"
              />
            </Link>
            <button class="nav_center" onClick={toggle}>
              <a href="https://instagram.com/imarangatubeach?igsh=MTY5enViNXJmbzNjYQ==">
                <Instagram
                  style={{
                    fontSize: "37px",
                    paddingRight: "15px",
                    // marginBottom: "-5px",
                  }}
                  className="icons"
                />
              </a>
            </button>

            <Link class="nav_center" to={"/location"} onClick={toggle}>
              <Place
                style={{
                  // color: "#53ddf9",
                  fontSize: "37px",
                  paddingRight: "15px",
                }}
                className="icons"
              />
            </Link>
          </div>

          <div className="option">
            <button
              className="lang_m"
              onClick={() => {
                setEnglish();
                toggle();
              }}
            >
              EN
            </button>
            <button
              className="lang_m"
              onClick={() => {
                setSpanish();
                toggle();
              }}
            >
              ES
            </button>
            <button
              className="lang_m"
              onClick={() => {
                setPortuguese();
                toggle();
              }}
            >
              PR
            </button>
          </div>
        </div>
      </motion.div>
    );
  };

  const MobileView = () => {
    return (
      <div className="navbarclosedmobile">
        <Link class="logo_container" to={"/"}>
          <img alt="logo" src={logo} className="logo_mobile" />
        </Link>
        <button className="icon">
          {isOpen ? (
            <CloseIcon
              onClick={() => setIsOpen(false)}
              style={{ color: "#fff", height: 32, width: 32 }}
            />
          ) : (
            <MenuIcon
              onClick={() => setIsOpen(true)}
              style={{ color: "#fff", height: 32, width: 32 }}
            />
          )}
        </button>
        {isOpen && <Drawer show={isOpen} onClose={toggle} isOpen={isOpen} />}
      </div>
      // <div className="navbarclosedmobile">
      //   <Link to={"/"}></Link>
      //   <button className="icon">
      //     {isOpen ? (
      //       <CloseIcon
      //         onClick={() => setIsOpen(false)}
      //         style={{ color: "#fff" }}
      //       />
      //     ) : (
      //       <MenuIcon
      //         onClick={() => setIsOpen(true)}
      //         style={{ color: "#fff" }}
      //       />
      //     )}
      //   </button>
      //   <Drawer
      //     show={isOpen}
      //     onClose={() => setIsOpen(false)}
      //     isOpen={isOpen}
      //   />
      // </div>
    );
  };

  const DesktopView = () => {
    return (
      <div className="navbarclosed">
        <div className="nav_right">
          <button className="home_button">
            <a className="nav_option" href="https://imarangatu.meitre.com/">
              <text>{i18n({ index: "reserve", language })}</text>
            </a>
          </button>
          <button className="home_button">
            <HashLink className="nav_option" smooth to={"/contact"}>
              <text>{i18n({ index: "contact", language })}</text>
            </HashLink>
          </button>
        </div>
        <Link class="nav_center" to={"/"}>
          <img src={logo} className="header_img" alt="logo" />
        </Link>
        <div className="nav_right">
          <div className="icons">
            <Link class="nav_center" to={"/music"}>
              <HeadphonesSharpIcon
                style={{
                  fontSize: "37px",
                  paddingRight: "15px",
                  // marginBottom: "-5px",
                }}
                className="icons"
              />
            </Link>
            <button class="nav_center">
              <a href="https://instagram.com/imarangatubeach?igsh=MTY5enViNXJmbzNjYQ==">
                <Instagram
                  style={{
                    fontSize: "37px",
                    paddingRight: "15px",
                    // marginBottom: "-5px",
                  }}
                  className="icons"
                />
              </a>
            </button>

            <Link class="nav_center" to={"/location"}>
              <Place
                style={{
                  // color: "#53ddf9",
                  fontSize: "37px",
                  paddingRight: "15px",
                }}
                className="icons"
              />
            </Link>
          </div>
          <div className="langs">
            <button className="lang" onClick={() => setEnglish()}>
              EN
            </button>
            <button onClick={() => setSpanish()} className="lang">
              ES
            </button>
            <button onClick={() => setPortuguese()} className="lang">
              PR
            </button>
          </div>
        </div>
      </div>
    );
  };

  return isMobile ? <MobileView /> : <DesktopView />;
};
